import { UtilService as util } from "../Services/UtilService";

export class CampusSwitcherModule {

    static async Init() {

        DEBUG && console.info('*--> CampusSwitcher Module Init');

        var elements = document.querySelectorAll('[data-component="campusSwitcher"]');

        elements.forEach(element => {
            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info('**************************************************');

            this.initSwitcher();
        });


        var elementsSwitcher = document.querySelectorAll('[data-component="campusSelector"]');

        elementsSwitcher.forEach(element => {
            var fragment = element.getAttribute('data-urlFragment');
            var keyName = element.getAttribute('data-keyName');
            var keyValue = element.getAttribute('data-keyValue');
            
            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Url Fragment:            ${fragment}`);
            DEBUG && console.info(`Key Name:                ${keyName}`);
            DEBUG && console.info(`Key Value:               ${keyValue}`);
            DEBUG && console.info('**************************************************');

            this.initSelector(fragment, element.id, keyName, keyValue);
        });        

        var elementsSwitcher = document.querySelectorAll('[data-component="campusSetter"]');

        elementsSwitcher.forEach(element => {

            var campus = element.getAttribute('data-campus');
            var redirectCampus = element.getAttribute('data-redirectCampus');
            var setCampus = element.getAttribute('data-setCampus');

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Campus:                  ${campus}`);
            DEBUG && console.info(`Redirect:                ${redirectCampus}`);
            DEBUG && console.info(`Set Campus:               ${setCampus}`);
            DEBUG && console.info('**************************************************');

            if (!campus) {
                DEBUG && console.info('**************************************************');
                console.warn('===> No campus set for Campus Setter Widget.  Unable to process action.');
                DEBUG && console.info('**************************************************');
                return;
            }

            this.initSetter(campus, redirectCampus, setCampus);
        });    

        var elementsClear = document.querySelectorAll('[data-component="campusClear"]');

        elementsClear.forEach(element => {

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info('**************************************************');
            this.initClear();
        });   


        var elementsMake = document.querySelectorAll('[data-component="makeMyCampus"]');

        elementsMake.forEach(element => {

            var campus = element.getAttribute('data-campus');
            var buttonElementId = element.getAttribute('data-button');

            const buttonElement = document.getElementById(buttonElementId);

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Campus:                  ${campus}`);
            DEBUG && console.info(`Button Element ID:       ${buttonElementId}`);
            DEBUG && console.info('**************************************************');
            this.initMakeMyCampus(campus, buttonElement);
        });  
        
    }    


    static initSwitcher() {
        if (util.getCampus()) {
            window.location.href = `/${util.getCampus()}`;
        }
        else {
            console.info('===> No Saved Campus Detected <===');
        }
    }

    static initSelector(fragment, elementId, keyName, keyValue) {
        if (util.getCampus()) {
            let url = `/${util.getCampus()}/${fragment}`;

            if (keyName && keyValue) {
                url += `?${keyName}=${keyValue}`;
            }

            window.location.href = url;
        }
        else {
            console.info('===> No Saved Campus Detected <===');
            console.info('===> Campus Selector Content Shown <===');

            var selectorContent = document.getElementById(`selectorContent${elementId}`);
            selectorContent.style.display = "block";
        }
    }

    static initSetter(campus, redirectCampus, setCampus) {

        if (campus && setCampus == "true") {
            util.setCampus(campus);
        }        

        if (redirectCampus == 'true') {
            window.location.href = `/${campus}`;
        }
    }

    static initClear() {

        var btnClearElements = document.querySelectorAll('.btnClearCampus');

        if (util.getCampus()) {
            console.info('===> Campus Detected <===');

            btnClearElements.forEach(element => {

                element.style.display = "block";

                element.addEventListener('click', function () {
                    util.clearCampus();
                    alert('Campus Cleared');
                    element.style.display = "none";
                });
            });
        }
        else {
            btnClearElements.forEach(element => {
                element.style.display = "none";
            });
        }
    }

    static initMakeMyCampus(campus, buttonElement) {

        if (util.getCampus()) {

            buttonElement.style.display = "none";

            var classElements = document.querySelectorAll('.makeMyCampus');

            classElements.forEach(element => {

                element.style.display = "none";

            }); 
        }
        else {
            buttonElement.style.display = "block";

            let self = this;

            buttonElement.addEventListener('click', function () {
                console.info(`===> Setting Campus to: ${campus}`);
                self.setCampus(campus);

                var classElements = document.querySelectorAll('.makeMyCampus');
                classElements.forEach(element => {
                    element.style.display = "none";
                }); 
            });           
        }
    }
}